export const TOP_CLICKED_REGION_CLASS_PREFIX = 'top-clicked-region-';

export const CLICK_REGION_BASE_Z_INDEX = 100;
